import React from 'react';
import { DumbbellIcon, CalendarCheckIcon, ActivityIcon, FootprintsIcon, TrendingUpIcon, SlidersHorizontalIcon, CalendarRangeIcon, ClipboardListIcon } from 'lucide-react';
const capabilities = [{
  icon: DumbbellIcon,
  label: 'Exercise Selection'
}, {
  icon: CalendarCheckIcon,
  label: 'Class Planning'
}, {
  icon: ActivityIcon,
  label: 'Strength & Mobility'
}, {
  icon: FootprintsIcon,
  label: 'Balance Training'
}, {
  icon: TrendingUpIcon,
  label: 'Session Progressions'
}, {
  icon: SlidersHorizontalIcon,
  label: 'Ability-Level Adaptations'
}, {
  icon: CalendarRangeIcon,
  label: 'Long-Term Programming'
}, {
  icon: ClipboardListIcon,
  label: 'Professional Coaching Tools'
}];
export function IncludedGrid() {
  return <section className="bg-ivory px-4 sm:px-6 py-9 sm:py-12" data-id="element-98" data-mp="3pm27j0gc814p">
      <div className="max-w-4xl mx-auto" data-id="element-99" data-mp="qwk3wxno496o">
        <h2 className="font-heading font-extrabold uppercase text-base sm:text-2xl leading-tight tracking-tight text-petrol text-center mb-6 max-w-2xl mx-auto" data-id="element-100" data-mp="qyesqn228lg1">
          Everything your senior fitness program needs —{' '}
          <span className="text-green-dark" data-id="element-101" data-mp="1o2kn4i74bxda">in one place</span>
        </h2>

        <ul className="grid grid-cols-2 lg:grid-cols-4 gap-2" data-id="element-102" data-mp="1o4opuwta6qbz">
          {capabilities.map(({
          icon: Icon,
          label
        }) => <li key={label} className="bg-white border border-petrol/10 rounded-lg px-3 py-3.5 flex flex-col items-center text-center gap-1.5" data-id="element-103" data-mp="1ecrd3lmmjqb5">
              <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-green shrink-0" data-id="element-104" data-mp="10fckk812r2ey" />
              <span className="font-heading font-bold uppercase text-[9px] sm:text-[11px] tracking-wide text-petrol leading-snug" data-id="element-105" data-mp="15de2gpmrkvou">
                {label}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}